import React from 'react';
import '../Styles/OurVisionPage.css';
//import Lottie from "lottie-react";
//import anime11 from "../animations/anime11.json";
import '../Styles/FounderMessage.css';


const FounderMessage = () => {
    return (
        <section className="founder-message">
            <div className="letter-container">
                <p>Merhaba,</p>

                <p>
                    MeduVR olarak Türkiye’nin ilk ve tek sanal gerçeklik tabanlı eğitim uygulamasını hayata geçirmenin
                    gururunu yaşıyoruz.
                    Hedef gruplara yönelik simülasyonlar ve VR teknolojisi ile geliştirilmiş içerikler sunarak, tıbbi
                    görüntüleme eğitiminde
                    devrim yaratmayı ve kullanıcılarımıza pratik, etkileşimli bir öğrenme deneyimi sunmayı hedefliyoruz.
                </p>

                <p>
                    2018 yılında, Türkiye’nin ilk sanal gerçeklik tabanlı eğitim uygulaması olarak başladığımız bu
                    yolculukta, Bilimsel Araştırma
                    Projeleri Birimi (BABKO) tarafından desteklenen "Tıbbi Görüntüleme Teknikleri Eğitiminde Sanal
                    Gerçeklik" projesiyle ilk
                    adımlarımızı attık. 2020 yılında Bayer’in G4A Turkey programından aldığımız destekle projelerimizi
                    genişlettik ve 2021
                    yılında RSG Bilgi Teknolojileri Sağlık ve İnovasyon Ltd. Şti.’nin kurucu ortağı olarak Teknopark'ta
                    AR-GE projeleri
                    geliştirmeye devam ettik.
                </p>

                <p>
                    Aynı yıl, Sanayi Bakanlığı'na projeler hazırlayarak sektörün ihtiyaçlarına yönelik yenilikçi
                    çözümler üretmeye başladık.
                    2022 yılında KOSGEB İleri Girişimci Destek Programı tarafından aldığımız destekle kadın
                    girişimciliğini teşvik eden projeler
                    geliştirdik. 2023 yılında, Cumhurbaşkanlığı Strateji ve Bütçe Başkanlığı ile Yükseköğretim Kurulu
                    Başkanlığı’nın Araştırma
                    Üniversiteleri Destek Programı (ADEP) kapsamında "Sanal Gerçeklik Teknolojisi VR ile Meme Kanseri
                    Erken Tanı ve Tarama
                    Prototipinin Geliştirilmesi" projesi yatırım desteği alarak bu alanda önemli adımlar attık.
                </p>

                <p>
                    Bu projeler, kadınlara meme kanseri tanı-tarama yöntemleri konusunda deneyim kazandırarak
                    farkındalık sağlamayı amaçlamaktadır.
                </p>

                <p>
                    Misyonumuz, sanal gerçeklik teknolojisini tıbbi görüntüleme eğitiminde yenilikçi çözümler sunmak ve
                    kullanıcılarımıza
                    etkileşimli bir öğrenme deneyimi sağlamaktır. VR teknolojisini kullanarak kadınlara meme sağlığı,
                    mamografi, Kendi Kendine
                    Meme Muayenesi (KKMM) ve Klinik Meme Muayenesi (KMM) gibi konularda deneyim kazandırmayı ve
                    farkındalık sağlamayı amaçlıyoruz.
                </p>

                <p>
                    Vizyonumuz, tıbbi görüntüleme eğitiminde sanal gerçeklik teknolojisinin lideri olmak ve global
                    ölçekte tanınan bir eğitim
                    platformu haline gelmektir. Kadın girişimciliğini destekleyerek, iş dünyasında kadınların daha aktif
                    rol almasını sağlamak
                    da vizyonumuzun önemli bir parçasıdır. Ayrıca, VR teknolojisi ve meme sağlığı konusunda farkındalık
                    geliştirmelerine katkıda
                    bulunmayı hedefliyoruz.
                </p>

                <p>
                    MeduVR olarak, tıbbi görüntüleme eğitimi alanında yenilikçi çözümler üretmeye ve farkındalık
                    yaratmaya devam edeceğiz.
                </p>

                <div className="signature">
                    Saygılarımla,<br/>
                    <strong>Doç. Dr. Nuran Akyurt</strong><br/>
                    Proje Yürütücüsü, Kurucu ve Genel Müdür
                </div>
            </div>
        </section>
    );
};

export default FounderMessage;